var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmployee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 121.53 181.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".prefix__employee-1{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__employee-1",
    d: "M108.62 47.93l-4.45-3.52A43.49 43.49 0 0071.25 3.49v-1A2.45 2.45 0 0068.8 0H52.73a2.45 2.45 0 00-2.45 2.45v1a43.49 43.49 0 00-32.92 40.96l-4.45 3.52a2.43 2.43 0 00-.91 1.92v6.9a2.45 2.45 0 002.45 2.45H26.7V80a34.07 34.07 0 1068.13 0V59.2h12.27a2.45 2.45 0 002.45-2.45v-6.9a2.43 2.43 0 00-.93-1.92zM89.93 80a29.17 29.17 0 01-58.33 0V59.2h58.33zm14.72-25.7H16.88V51l4.44-3.5a2.5 2.5 0 00.93-1.93 38.57 38.57 0 0128-37V14a2.46 2.46 0 004.91 0V4.91h11.19V14a2.45 2.45 0 004.9 0V8.56a38.57 38.57 0 0128 37.05 2.5 2.5 0 00.93 1.93l4.44 3.5zM121.53 181.71H0v-21.89A34.88 34.88 0 0134.85 125h51.83a34.88 34.88 0 0134.85 34.84zM4.89 176.82h111.75v-17a30 30 0 00-30-29.95H34.85a30 30 0 00-30 29.95z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee);
export default __webpack_public_path__ + "static/media/employee.e0fae0b2.svg";
export { ForwardRef as ReactComponent };